import { styled } from "@enfusion-ui/web-core";
import { faMinus, faTimes } from "@fortawesome/pro-solid-svg-icons";
import * as React from "react";
import { MacExpandIcon } from "../icons";
import { closeWindow, maximizeWindow, minimizeWindow } from "./actions";
import CircleIconButton from "./CircleIconButton";
const FlexPlaceholder = styled.div `
  height: 20px;
  flex: 1;
`;
const ActionContainer = styled.div `
  margin-left: var(--spacing);
  height: 23px;
  flex: 1;
  display: flex;
  flex-direction: row;
  -webkit-app-region: no-drag;
  -app-region: no-drag;
`;
const CenterTitleContainer = styled.div `
  height: 20px;
  flex: 18;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  opacity: ${({ active }) => {
    if (active)
        return "1";
    return "0.5";
}};
`;
const MacActionsContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const MacActions = ({ active, maximized, }) => {
    const [hasMouse, setHasMouse] = React.useState(false);
    const handleEnter = () => setHasMouse(true);
    const handleLeave = () => setHasMouse(false);
    return (React.createElement(MacActionsContainer, { onMouseEnter: handleEnter, onMouseLeave: handleLeave },
        React.createElement(CircleIconButton, { icon: faTimes, title: "close", color: "#FF605C", onClick: closeWindow, active: active, focus: hasMouse }),
        React.createElement(CircleIconButton, { style: { marginLeft: "0.5rem" }, icon: faMinus, title: "minimize", color: "#FFBD44", onClick: minimizeWindow, active: active, focus: hasMouse }),
        React.createElement(CircleIconButton, { style: { marginLeft: "0.5rem" }, iconComp: React.createElement(MacExpandIcon, null), title: maximized ? "restore" : "maximize", color: "#00CA4E", onClick: maximizeWindow, active: active, focus: hasMouse })));
};
const MacTopBar = ({ title, active, actions, maximized }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionContainer, null, actions ? React.createElement(MacActions, { active: active, maximized: maximized }) : null),
        React.createElement(CenterTitleContainer, { active: active }, title),
        React.createElement(FlexPlaceholder, null)));
};
export default MacTopBar;
